import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './About.css';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="about-section" id="about" ref={ref} data-testid="about-section">
      <div className="container">
        <motion.div
          className="about-content"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title" data-testid="about-title">
            About DanstonAI
          </h2>
          <div className="about-text">
            <p data-testid="about-paragraph-1">
              DanstonAI is a next-generation artificial intelligence company focused on building powerful, reliable, and scalable AI solutions for businesses across every sector.
            </p>
            <p data-testid="about-paragraph-2">
              Our mission is to simplify work, automate operations, and empower organizations with AI that works nonstop.
            </p>
            <p data-testid="about-paragraph-3">
              We believe that AI isn't just a tool—it's a competitive advantage that enables businesses to operate smarter, faster, and more efficiently than ever before.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
